import React, {useState, useRef, useEffect} from "react";
import {Button} from 'primereact/button';
import axios from "axios";
import {Toast} from "primereact/toast";
import {Dialog} from "primereact/dialog";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputText} from "primereact/inputtext";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {Tag} from "primereact/tag";
import {MultiSelect} from "primereact/multiselect";
import {Message} from "primereact/message";
import {InputTextarea} from "primereact/inputtextarea";
import Spinner from "../../spinner/Spinner";
import {TabPanel, TabView} from "primereact/tabview";
import {Panel} from "primereact/panel";
import {Knob} from "primereact/knob";
import {InputNumber} from "primereact/inputnumber";
import {ConfirmPopup, confirmPopup} from 'primereact/confirmpopup';


const ModuleReservations = props => {
    const toast = useRef(null);
    const [allReservationList, setAllReservationList] = useState([]);
    const [pendingList, setPendingList] = useState([]);
    const [approvedReservationList, setApprovedReservationList] = useState([]);
    const [rejectReservationList, setRejectReservationList] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [sssDeleteDialog, setSssDeleteDialog] = useState(false);
    const [umdID, setUmdID] = useState(null);
    const role_list = !!localStorage.getItem('role_list');
    const [globalFilter1, setGlobalFilter1] = useState('');
    const [descriptionDialogHeader, setDescriptionDialogHeader] = useState("");
    const [descriptionDialogContent, setDescriptionDialogContent] = useState("");
    const [descriptionDialog, setDescriptionDialog] = useState(false);
    const [acceptDialog, setAcceptDialog] = useState(false);
    const [roleValue, setRoleValue] = useState(null);
    const [mdID, setMdID] = useState(null);
    const [creditRejectedDescription, setCreditRejectedDescription] = useState("");
    const [loadingState, setLoadingState] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [pendingCount, setPendingCount] = useState(0);
    const [userID, setUserID] = useState('');
    const [degValue, setDegValue] = useState(0);
    const [megValue, setMegValue] = useState(0);
    const [totaldegApp, setTotaldegApp] = useState(0);
    const [totalmegApp, setTotalmegApp] = useState(0);
    const [umdStartTime, setUmdStartTime] = useState(null)
    const [totalAll, setTotalAll] = useState(0);
    const [totalPending, setTotalPending] = useState(0);
    const [totalApproved, setTotalApproved] = useState(0);
    const [totalRejected, setTotalRejected] = useState(0);
    const [firstAll, setFirstAll] = useState(0);
    const [firstPending, setFirstPending] = useState(0);
    const [firstApproved, setFirstApproved] = useState(0);
    const [firstRejected, setFirstRejected] = useState(0);


    useEffect(() => {

        getUserModuleList(0)
        getApprovedReservations(0)
        getPendindApprovalReservations(0)
        getUserModuleListPending(0)
        getModuleLimit()


    }, []); //Buradaki dizi içine yazılan değer, değişince useeffecti çalıştır.


    const customer1TableHeader = (
        <div className="table-header" align="right">

            <span className="p-input-icon-left">
                <i className="pi pi-search"/>
                <InputText value={globalFilter1} onChange={(e) => setGlobalFilter1(e.target.value)}
                           placeholder="Genel Arama"/>
            </span>
        </div>
    );

    const filterByGlobal = (list) => {
        if (!globalFilter1 || !globalFilter1.trim()) return list;
        const q = globalFilter1.toLowerCase();
        return list.filter(row =>
            Object.values(row).some(val =>
                String(val != null ? val : '').toLowerCase().includes(q)
            )
        );
    };

    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 5000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 5000
        });
    }

    const modelegitimTemplate = () => {

        return (
            <div align="center">

                <h6><b>Model Eğitim Portal Kullanım Başvuru Limiti Belirle</b>
                </h6>


            </div>
        )
    }

    const degirmenTemplate = () => {

        return (
            <div>
                <h6><b>Değirmen Portal Kullanım Başvuru Limiti Belirle</b>
                </h6>

            </div>
        )
    }

    const getApprovedReservations = (page) => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch(`/api/md-reservation/approved/${page}/`, {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            setApprovedReservationList(res.data.user_module_list_accept);
                            setTotalApproved(res.data.total_records || 0);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;
                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;
                    }
                })
        }
    }

    const getPendindApprovalReservations = (page) => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch(`/api/md-reservation/rejected/${page}/`, {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            setRejectReservationList(res.data.user_module_list_reject);
                            setTotalRejected(res.data.total_records || 0);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;
                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;
                    }
                })
        }
    }

    const getModuleLimit = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/md-user-limit/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;
                        setDegValue(data.deg_total_limit)
                        setMegValue(data.meg_total_limit)
                        setTotaldegApp(data.deg_total_application)
                        setTotalmegApp(data.meg_total_application)

                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;
                    }
                })

        }
    }

    const getUserRoleList = (umd_id, md_id, start_time, user_id) => {
        setUserID(user_id)
        setUmdStartTime(start_time)
        setMdID(md_id)
        setUmdID(umd_id)
        setAcceptDialog(true)
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/md-roles/' + `${md_id}/`, {"headers": headers})
            .then(res => {
                setRoleList(res.data.user_role_list)
            })
    }

    const getUserModuleList = (page) => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get(`/api/md-reservation/all/${page}/`, {"headers": headers})
            .then(res => {
                setAllReservationList(res.data.user_module_list || [])
                setTotalAll(res.data.total_records || 0)
            })
    }

    const getUserModuleListPending = (page) => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get(`/api/md-reservation/pending/${page}/`, {"headers": headers})
            .then(res => {
                setPendingList(res.data.user_module_list || [])
                setPendingCount(res.data.count || 0)
                setTotalPending(res.data.total_records || 0)
            })
    }

    const statusTemplate = (rowData) => {
        let status = rowData.umd_flag_permission
        if (status === null) {
            return <div>
                <React.Fragment>


                    <Tag className="mr-2" severity="warning" value="Onay Bekliyor" rounded/>


                </React.Fragment>


            </div>;

        } else if (status === true) {
            return <div>
                <React.Fragment>

                    <Tag className="mr-2" severity="success" value="Onaylanmış" rounded/>


                </React.Fragment>


            </div>;

        } else if (status === false) {
            return <div>
                <React.Fragment>


                    <Tag severity="danger" value="İptal Edilmiş" rounded/>


                </React.Fragment>


            </div>;

        }

    }

    const deleteRow = (umd_id) => {


        setSssDeleteDialog(true)
        setUmdID(umd_id)


    }

    const submit = () => {
        const obj = {
            umdStartTime: umdStartTime,
            userID: userID,
            umdID: umdID,
            rolg_id: roleValue,
            md_id: mdID
        };

        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            const body = JSON.stringify(obj);
            if (umdID) {
                fetch("/api/user-role-add/", {headers, method: "POST", body})
                    .then(res => {
                        if (res.status < 500) {
                            return res.json().then(data => {
                                return {status: res.status, data};
                            })
                        } else {
                            //console.log("Server Error!");
                            throw res;
                        }
                    })
                    .then(res => {
                        if (res.status === 200) {
                            const data = res.data;

                            if (data.result) {
                                getUserModuleList(0)
                                getApprovedReservations(0)
                                getPendindApprovalReservations(0)
                                getUserModuleListPending(0)
                                setFirstAll(0); setFirstPending(0); setFirstApproved(0); setFirstRejected(0);
                                setAcceptDialog(false)
                                showSuccess(data.message);
                            } else {
                                showError(data.message);
                                // this.setState({disable_submit_btn: false});
                            }
                        } else if (res.status === 401) {
                            props.loadUser();
                            throw res.data;

                        } else if (res.status === 403) {
                            throw res.data;

                        }
                    })
            }
        }


    }

    const submitDegirmen = () => {
        const obj = {
            mdModuleID: 5,
            mdValue: degValue
        };

        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            const body = JSON.stringify(obj);
            fetch("/api/md-user-limit/", {headers, method: "PUT", body})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;

                        if (data.result) {
                            showSuccess(data.message);

                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        throw res.data;

                    } else if (res.status === 403) {
                        throw res.data;

                    }
                })

        }


    }

    const submitModel = () => {
        const obj = {
            mdModuleID: 6,
            mdValue: megValue
        };

        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            const body = JSON.stringify(obj);
            fetch("/api/md-user-limit/", {headers, method: "PUT", body})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;

                        if (data.result) {
                            showSuccess(data.message);
                        } else {
                            showError(data.message);
                            // this.setState({disable_submit_btn: false});
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        throw res.data;

                    } else if (res.status === 403) {
                        throw res.data;

                    }
                })
        }
    }

    const ModuleOptionItems = roleList.map((item) => (
        {"label": item.rolg_name, "value": item.rolg_id}
    ))

    const deleteCip = (umd_id) => {
        if (creditRejectedDescription !== "") {
            const obj = {
                creditRejectedDescription: creditRejectedDescription

            }
            const token = localStorage.getItem("token");

            const headers = {"Authorization": "Token " + token}
            axios.put('api/md-reservation' + `/${umd_id}/`, obj, {"headers": headers})
                .then(res => {
                    const data = res.data
                    if (data.result) {
                        setCreditRejectedDescription('')
                        getUserModuleList(0)
                        getApprovedReservations(0)
                        getPendindApprovalReservations(0)
                        getUserModuleListPending(0)
                        setFirstAll(0); setFirstPending(0); setFirstApproved(0); setFirstRejected(0);
                        showSuccess(data.message);

                    } else {
                        showError(data.message);
                    }
                    getUserModuleList(0)

                    setSssDeleteDialog(false)
                    setUmdID(null)


                });


        } else {
            showError("Başvuru iptal açıklaması boş bırakılamaz!");

        }
    }

    
    const moduleTemplate = (rowData) => {
        console.log(rowData, "rowdata")
        let status = rowData.md_id;
        if (status === 5) {
            return (
                <div>
                    <React.Fragment>
                        <Tag className="mr-2" severity="info" value="Değirmen Portal" rounded/>
                    </React.Fragment>
                </div>
            );
        } else if (status === 6) {
            return (
                <div>
                    <React.Fragment>
                        <Tag className="mr-2" severity="success" value="Model Eğitim Portal" rounded/>
                    </React.Fragment>
                </div>
            );
        } else if (status === 4) {
            return (
                <div>
                    <React.Fragment>
                        <Tag className="mr-2" severity="warning" value="Veri Kovanı Portal" rounded/>
                    </React.Fragment>
                </div>
            );
        } else if (status === 15) {
            return (
                <div>
                    <React.Fragment>
                        <Tag className="mr-2" severity="info" value="Kıyasla Portali" rounded/>
                    </React.Fragment>
                </div>
            );
        } else if (status === 13) {
            return (
                <div>
                    <React.Fragment>
                        <Tag className="mr-2" severity="success" value="Eğitim Portali" rounded/>
                    </React.Fragment>
                </div>
            );
        } else if (status === 14) {
            return (
                <div>
                    <React.Fragment>
                        <Tag className="mr-2" severity="warning" value="Simülasyon Portali" rounded/>
                    </React.Fragment>
                </div>
            );
        }

        return <span>{rowData.md__md_name || "-"}</span>;
    }

    const descriptionDialogOnDisplay = (header, content) => {
        setDescriptionDialogHeader(header);
        setDescriptionDialogContent(content);
        setDescriptionDialog(true);
    }
    const rejectDialog = () => {
        setAcceptDialog(false)
        setRoleValue('')
    }

    const descriptionDialogOnHide = () => {
        setDescriptionDialogHeader("");
        setDescriptionDialogContent("");
        setDescriptionDialog(false);
    }
    const getDescriptionBody = (key, title) => {
        const descriptionBody = (rowData) => {
            console.log(rowData[key].umd_reservation_reason, "----------")
            return (
                <React.Fragment>
                    <div>
                        <div className="p-grid">
                            <div className="p-col-12">
                                <span className="p-column-title">{title}</span>
                            </div>
                            <div className="p-col-12" style={{wordBreak: "break-all"}}>
                                {rowData[key].umd_reservation_reason
                                    ?
                                    rowData[key].umd_reservation_reason.length > 20
                                        ?
                                        <div>
                                            {rowData[key].umd_reservation_reason.substring(0, 20) + "..."}
                                            {rowData[key].select_role}
                                            <Button label="Devamını Oku"
                                                    onClick={(e) => descriptionDialogOnDisplay(title, rowData[key].umd_reservation_reason)}
                                                    className="p-button-text"
                                            />
                                        </div>
                                        :
                                        <div>
                                            {rowData[key].umd_reservation_reason}

                                        </div>

                                    :
                                    <span><b>-</b></span>
                                }

                            </div>

                        </div>
                    </div>

                </React.Fragment>
            );
        }
        return descriptionBody;
    }
    const roleTemplate = (key) => {
        const descriptionBody = (rowData) => {
            return (
                <div className="p-grid">

                    {rowData[key].select_role
                        ?
                        <div className="p-col-12">
                            {rowData[key].select_role.map((role) =>

                                <p>
                                    {role === "annotations"
                                        ?
                                        "Veri Seti Sağlayıcısı"
                                        :
                                        role === "annotate"
                                            ?
                                            "Aday Etiketleyici"
                                            :
                                            role}
                                </p>
                            )}
                        </div>

                        :
                        <span><b>-</b></span>
                    }
                </div>
            );
        }
        return descriptionBody;
    }

    const confirm1 = (event) => {
        confirmPopup({
            target: event.currentTarget,
            message: 'Çok sayıda kullanıcı erişimi sistemsel sorunlara yol açabilmektedir. Onaylıyor musunuz?',
            icon: 'pi pi-exclamation-triangle',
            accept() {
                submitModel()
            },
            reject() {

            }
        });
    };
    const confirm2 = (event) => {
        confirmPopup({
            target: event.currentTarget,
            message: 'Çok sayıda kullanıcı erişimi sistemsel sorunlara yol açabilmektedir. Onaylıyor musunuz?',
            icon: 'pi pi-exclamation-triangle',
            accept() {
                submitDegirmen()
            },
            reject() {

            }
        });
    };

    const actionTemplate = (rowData) => {
        return <div>


            <Button icon="pi pi-check" className=" p-button-success p-mr-2" tooltip="Onayla"

                    onClick={() => getUserRoleList(rowData.umd_id, rowData.md_id, rowData.umd_starttime, rowData.user_id)}
                    tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}

            />


            <Button icon="pi pi-times" className=" p-button-danger"

                    onClick={() => deleteRow(rowData.umd_id)}
                    tooltip="Reddet"
                    tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
            />


        </div>;
    }

    const controllerTemplate = (rowData) => {
        return <div>{rowData.umd_controller__user_username ? rowData.umd_controller__user_username : "Sistem"}</div>;
    }

    if (role_list) {
        return (

            <div>
                <ConfirmPopup/>
                <Spinner loadingState={loadingState}/>
                <Dialog header="UYARI" visible={sssDeleteDialog}
                        style={{width: '50%'}}

                        onHide={() => setSssDeleteDialog(false)}>
                    <div className="p-grid">
                        <div className="p-col-12">
                            <div className="p-field p-md-4 p-mt-5" style={{width: '100%'}}>
                                <span className="p-float-label">
                                    <InputTextarea id="rejectedDescription" value={creditRejectedDescription}
                                                   onChange={(e) => setCreditRejectedDescription(e.target.value)}
                                                   rows={3}
                                                   style={{width: '100%'}}
                                    />
                                    <label htmlFor="rejectedDescription">Kredi İptal Açıklaması</label>
                                </span>
                            </div>
                        </div>
                        <div className="p-col-12" align="right">
                            <Button label="İptal Et"
                                    className="p-button-danger"
                                    icon="pi pi-times"
                                    onClick={() => deleteCip(umdID)}/>
                        </div>
                    </div>


                </Dialog>

                <Dialog visible={descriptionDialog}
                        onHide={descriptionDialogOnHide}
                        header={descriptionDialogHeader}
                        style={{width: '75%'}}
                        dismissableMask
                >
                    <div className="p-grid">
                        <div className="p-col-12">
                            <p style={{fontSize: '1.25rem'}}> {descriptionDialogContent} </p>

                        </div>
                    </div>
                </Dialog>
                <Dialog visible={acceptDialog}
                        onHide={rejectDialog}
                        header="Başvuru Onayla"
                        style={{width: '60%'}}
                        maximizable
                        dismissableMask
                >
                    <div className="p-grid">
                        <div className="p-col-12" align="center">
                            <Message severity="info" className="p-mt-2 p-mb-2"
                                     text="Kullanıcıya tanımlamak istediğiniz rol gruplarını seçiniz."/>
                            <MultiSelect value={roleValue}
                                         options={ModuleOptionItems}
                                         onChange={(e) => setRoleValue(e.value)} optionLabel="label"
                                         placeholder="Rol Gruplarını Seçiniz" display="chip"
                                         style={{width: '75%', align: 'center'}}/>
                        </div>
                        <div className="p-col-12 p-mt-5" align="right">
                            <Button label="Onayla"
                                    className="p-button-success"
                                    icon="pi pi-check"
                                    onClick={(e) => submit(umdID)}/>
                        </div>
                    </div>
                </Dialog>
                <Toast ref={toast}/>
                <div className="p-grid">
                    <div className="p-col-6" align="center">
                        <Panel toggleable header={modelegitimTemplate}>

                            <div className="p-grid">
                                <div className="p-col-6">
                                    <h5>Onaylanmış Model Eğitim Portal Başvuru Sayısı</h5>
                                    <Knob value={totalmegApp} valueColor="#689F38" disabled/>
                                </div>
                                <div className="p-col-6">
                                    <h5>Başvuru Limiti Belirle</h5>
                                    {/*<Knob value={megValue} onChange={(e) => setMegValue(e.value)} valueColor="#689F38"*/}
                                    {/*      min={0} max={2000}/>*/}
                                    <InputNumber id="vertical" value={megValue}
                                                 onValueChange={(e) => setMegValue(e.value)} mode="decimal" showButtons
                                                 buttonLayout="vertical" style={{width: '4rem'}}
                                                 decrementButtonClassName="p-button-success"
                                                 incrementButtonClassName="p-button-success"
                                                 incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"/>
                                    {/*<InputNumber className="p-mt-4" id="minmax" value={megValue} onValueChange={(e) => setMegValue(e.value)} mode="decimal" min={0} max={100} />*/}
                                </div>
                            </div>
                            <div>
                                <Button label="Onayla" className="p-button-rounded p-button-success"
                                        onClick={confirm1}/>

                            </div>

                        </Panel>
                    </div>
                    <div className="p-col-6" align="center">
                        <Panel toggleable header={degirmenTemplate}>
                            <div className="p-grid">
                                <div className="p-col-6">
                                    <h5>Onaylanmış Değirmen Portal Başvuru Sayısı</h5>
                                    <Knob value={totaldegApp} disabled/>
                                </div>
                                <div className="p-col-6">
                                    <h5>Başvuru Limiti Belirle</h5>
                                    {/*<Knob value={degValue} onChange={(e) => setDegValue(e.value)} min={0} max={100}/>*/}
                                    <InputNumber id="vertical" value={degValue}
                                                 onValueChange={(e) => setDegValue(e.value)} mode="decimal" showButtons
                                                 buttonLayout="vertical" style={{width: '4rem'}}
                                                 decrementButtonClassName="p-button-primary"
                                                 incrementButtonClassName="p-button-primary"
                                                 incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"/>
                                </div>
                            </div>
                            <div>
                                <Button label="Onayla" className="p-button-rounded p-button-primary"
                                        onClick={confirm2}
                                />

                            </div>
                        </Panel>
                    </div>
                </div>

                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="p-mt-3">
                    <TabPanel header="Tümü">
                        <div className="datatable-responsive-demo">


                            <div className="card">
                                <h5><b>Portal Kullanım Başvuruları</b></h5>
                                <p>Sayfalandırma, sıralama ve filtreleme </p>
                                <DataTable
                                    responsive={true}
                                    value={filterByGlobal(allReservationList)}
                                    paginator
                                    totalRecords={totalAll}
                                    first={firstAll}
                                    onPage={(e) => { setFirstAll(e.first); getUserModuleList(e.page); }}
                                    resizableColumns={true}
                                    className="p-datatable-responsive-demo"
                                    rows={10} dataKey="id"
                                    rowHover emptyMessage="Kayıt Bulunamadı."
                                    header={customer1TableHeader}

                                >
                                    <Column
                                        field={'umd_id'}
                                        header="No"
                                        style={{fontWeight: 'bold', width: '5.5em'}}
                                        sortable


                                    />
                                    <Column
                                        body={statusTemplate}
                                        header="Durumu"
                                        style={{fontWeight: 'bold'}}


                                    />


                                    <Column
                                        field={'user__user_username'}
                                        header="Talepte Bulunan"
                                        filter
                                        style={{textAlign: 'center'}}


                                    />

                                    <Column field="umd_reservationreason"
                                            header="Talep Açıklaması"
                                            body={getDescriptionBody("umd_reservationreason", "Talep Açıklaması")}
                                            style={{textAlign: 'center'}}
                                            sortable={true}
                                            filter={true}
                                            filterMatchMode="contains"
                                    />
                                    <Column field="umd_reservationreason"
                                            header="Talep Edilen Roller"
                                            body={roleTemplate("umd_reservationreason")}
                                            style={{textAlign: 'center'}}
                                            sortable={true}
                                            filter={true}
                                            filterMatchMode="contains"
                                    />
                                    <Column
                                        body={moduleTemplate}
                                        filterMatchMode="contains"
                                        header="Modül"
                                        filterField="md__md_name"
                                        style={{textAlign: 'center', fontWeight: 'bold'}}
                                        sortable={true}
                                        filter={true}


                                    />
                                    <Column
                                        field={'umd_reservationtime'}
                                        header="Oluşturulma Tarihi"
                                        style={{textAlign: 'center'}}
                                        sortable={true}
                                        filter={true}


                                    />
                                    <Column
                                        field={'umd_starttime'}
                                        header="Başlangıç Tarihi"
                                        style={{textAlign: 'center', fontWeight: 'bold'}}
                                        sortable={true}
                                        filter={true}
                                        filterMatchMode="contains"


                                    />
                                    <Column
                                        field={'umd_finishtime'}
                                        header="Bitiş Tarihi"
                                        style={{textAlign: 'center', fontWeight: 'bold'}}
                                        sortable={true}
                                        filter={true}
                                        filterMatchMode="contains"


                                    />


                                </DataTable>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header={<div style={{color: 'red'}}>Onay Bekleyen Başvurular ({pendingCount})
                    </div>}>
                        <div className="datatable-responsive-demo">

                            <div className="card">
                                <h5><b>Onay Bekleyen Başvurular</b></h5>
                                <p>Sayfalandırma, sıralama ve filtreleme </p>
                                <DataTable
                                    responsive={true}
                                    value={filterByGlobal(pendingList)}
                                    paginator
                                    totalRecords={totalPending}
                                    first={firstPending}
                                    onPage={(e) => { setFirstPending(e.first); getUserModuleListPending(e.page); }}
                                    resizableColumns={true}
                                    className="p-datatable-responsive-demo"
                                    rows={10} dataKey="id"
                                    rowHover emptyMessage="Kayıt Bulunamadı."
                                    header={customer1TableHeader}

                                >
                                    <Column
                                        field={'umd_id'}
                                        header="No"
                                        style={{fontWeight: 'bold', textAlign: 'left', width: '5.5em'}}
                                        sortable


                                    />

                                    <Column
                                        body={moduleTemplate}
                                        header="Modül"
                                        filterField="md__md_name"
                                        filterMatchMode="contains"
                                        style={{textAlign: 'center', fontWeight: 'bold'}}
                                        sortable={true}
                                        filter={true}


                                    />

                                    <Column
                                        field={'user__user_username'}
                                        header="Talepte Bulunan"
                                        filter
                                        style={{textAlign: 'center'}}


                                    />

                                    <Column field="umd_reservationreason"
                                            header="Talep Açıklaması"
                                            body={getDescriptionBody("umd_reservationreason", "Talep Açıklaması")}
                                            style={{textAlign: 'center'}}
                                            sortable={true}
                                            filter={true}
                                            filterMatchMode="contains"
                                    />
                                    <Column
                                        field={'umd_reservationtime'}
                                        header="Oluşturulma Tarihi"
                                        style={{textAlign: 'center'}}
                                        sortable={true}
                                        filter={true}
                                        filterMatchMode="contains"


                                    />
                                    <Column
                                        field={'umd_starttime'}
                                        header="Başlangıç Tarihi"
                                        style={{textAlign: 'center', fontWeight: 'bold'}}
                                        sortable={true}
                                        filter={true}
                                        filterMatchMode="contains"


                                    />
                                    <Column
                                        field={'umd_finishtime'}
                                        header="Bitiş Tarihi"
                                        style={{textAlign: 'center', fontWeight: 'bold'}}
                                        sortable={true}
                                        filter={true}
                                        filterMatchMode="contains"


                                    />


                                    <Column
                                        header="İşlevler"
                                        body={actionTemplate}
                                        style={{
                                            fontWeight: 'bold',
                                            width: '7.5em',
                                            // display: module_approval ? 'block' : 'none'
                                        }}
                                    />


                                </DataTable>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Onaylanmış Başvurular">
                        <div className="datatable-responsive-demo">

                            <div className="card">
                                <h5><b>Onaylanmış Başvurular</b></h5>
                                <p>Sayfalandırma, sıralama ve filtreleme </p>
                                <DataTable
                                    value={filterByGlobal(approvedReservationList)}
                                    className='p-datatable-responsive-demo'
                                    paginator
                                    totalRecords={totalApproved}
                                    first={firstApproved}
                                    onPage={(e) => { setFirstApproved(e.first); getApprovedReservations(e.page); }}
                                    rows={10}
                                    emptyMessage="Kayıt Bulunamadı"
                                    header={customer1TableHeader}
                                >
                                    <Column
                                        field={'umd_id'}
                                        header="No"
                                        style={{fontWeight: 'bold', textAlign: 'left', width: '5.5em'}}
                                        sortable


                                    />

                                    <Column
                                        body={moduleTemplate}
                                        header="Modül"
                                        filterField="md__md_name"
                                        filterMatchMode="contains"
                                        style={{textAlign: 'center', fontWeight: 'bold'}}
                                        sortable={true}
                                        filter={true}


                                    />

                                    <Column
                                        field={'user__user_username'}
                                        header="Talepte Bulunan"
                                        filter
                                        style={{textAlign: 'center'}}


                                    />
                                    <Column
                                        field={'umd_controller__user_username'}
                                        header="Kontrol Eden"
                                        filter
                                        style={{textAlign: 'center'}}


                                    />

                                    <Column field="umd_reservationreason"
                                            header="Talep Açıklaması"
                                            body={getDescriptionBody("umd_reservationreason", "Talep Açıklaması")}
                                            style={{textAlign: 'center'}}
                                            sortable={true}
                                            filter={true}
                                            filterMatchMode="contains"
                                    />
                                    <Column
                                        field={'umd_reservationtime'}
                                        header="Oluşturulma Tarihi"
                                        style={{textAlign: 'center'}}
                                        sortable={true}
                                        filter={true}
                                        filterMatchMode="contains"


                                    />
                                    <Column
                                        field={'umd_controltime'}
                                        header="Kontrol Tarihi"
                                        style={{textAlign: 'center'}}
                                        sortable={true}
                                        filter={true}
                                        filterMatchMode="contains"


                                    />
                                    <Column
                                        field={'umd_starttime'}
                                        header="Başlangıç Tarihi"
                                        style={{textAlign: 'center', fontWeight: 'bold'}}
                                        sortable={true}
                                        filter={true}
                                        filterMatchMode="contains"


                                    />
                                    <Column
                                        field={'umd_finishtime'}
                                        header="Bitiş Tarihi"
                                        style={{textAlign: 'center', fontWeight: 'bold'}}
                                        sortable={true}
                                        filter={true}
                                        filterMatchMode="contains"


                                    />


                                </DataTable>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Reddedilen Başvurular">
                        <div className="datatable-responsive-demo">

                            <div className="card">
                                <h5><b>Reddedilen Başvurular</b></h5>
                                <p>Sayfalandırma, sıralama ve filtreleme </p>

                                <DataTable
                                    value={filterByGlobal(rejectReservationList)}
                                    className='p-datatable-responsive-demo'
                                    paginator
                                    totalRecords={totalRejected}
                                    first={firstRejected}
                                    onPage={(e) => { setFirstRejected(e.first); getPendindApprovalReservations(e.page); }}
                                    rows={10}
                                    emptyMessage="Kayıt Bulunamadı"
                                    header={customer1TableHeader}
                                >
                                    <Column
                                        field={'umd_id'}
                                        header="No"
                                        style={{fontWeight: 'bold', textAlign: 'left', width: '5.5em'}}
                                        sortable


                                    />

                                    <Column
                                        body={moduleTemplate}
                                        filterField="md__md_name"
                                        header="Modül"
                                        filterMatchMode="contains"
                                        style={{textAlign: 'center', fontWeight: 'bold'}}
                                        sortable={true}
                                        filter={true}


                                    />

                                    <Column
                                        field={'user__user_username'}
                                        header="Talepte Bulunan"
                                        filter
                                        style={{textAlign: 'center'}}


                                    />
                                    <Column
                                        field={'umd_controller__user_username'}
                                        header="Kontrol Eden"
                                        filter
                                        style={{textAlign: 'center'}}
                                        body={controllerTemplate}

                                    />
                                    <Column
                                        body={getDescriptionBody("umd_controldesctiption", "Değerlendirme")}
                                        field={'umd_controldesctiption'}
                                        header="Değerlendirme"
                                        style={{textAlign: 'center'}}

                                    />


                                    <Column field="umd_reservationreason"
                                            header="Talep Açıklaması"
                                            body={getDescriptionBody("umd_reservationreason", "Talep Açıklaması")}
                                            style={{textAlign: 'center'}}
                                            sortable={true}
                                            filter={true}
                                            filterMatchMode="contains"
                                    />
                                    <Column
                                        field={'umd_reservationtime'}
                                        header="Oluşturulma Tarihi"
                                        style={{textAlign: 'center'}}
                                        sortable={true}
                                        filter={true}
                                        filterMatchMode="contains"


                                    />
                                    <Column
                                        field={'umd_controltime'}
                                        header="Kontrol Tarihi"
                                        style={{textAlign: 'center'}}
                                        sortable={true}
                                        filter={true}
                                        filterMatchMode="contains"


                                    />
                                    <Column
                                        field={'umd_starttime'}
                                        header="Başlangıç Tarihi"
                                        style={{textAlign: 'center', fontWeight: 'bold'}}
                                        sortable={true}
                                        filter={true}
                                        filterMatchMode="contains"


                                    />
                                    <Column
                                        field={'umd_finishtime'}
                                        header="Bitiş Tarihi"
                                        style={{textAlign: 'center', fontWeight: 'bold'}}
                                        sortable


                                    />
                                </DataTable>

                            </div>

                        </div>

                    </TabPanel>

                </TabView>
            </div>

        )
    } else {
        return (
            window.location.hash = "/notfound"
            // <Redirect to="#notfound"/>
        )
    }

}
const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ModuleReservations);



// WEBPACK FOOTER //
// ./src/pages/modulemanagement/ModuleReservations.jsx